import type { ReactNode } from "react";

import { useAuth } from "../auth/AuthProvider";

/** Renders children only when the active membership holds the permission code(s). */
export function PermissionGate({ permission, children, fallback = null }: {
  permission: string | string[];
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const { hasPermission } = useAuth();
  const codes = Array.isArray(permission) ? permission : [permission];
  return codes.every(hasPermission) ? <>{children}</> : <>{fallback}</>;
}
